let dd = require("ES/lib/dd");
let Modals = require("../modals");
let EventArea = require("./event_area/index");
let FullLayout = require("ES/widgets/FullLayout");
let CalendarArea = require("./calendar_area/index");
let StandardLayout = require("../layout/StandardLayout");
let YourBrowserWindowIsTooSmall = require("./YourBrowserWindowIsTooSmall");

module.exports = dd.createClass({
  render() {
    let { url_args, Displaylists } = this.props;

    return StandardLayout(
      { Displaylists },
      FullLayout({ horizontal: true }, [
        {
          body: CalendarArea({ Displaylists }),
        },
        {
          width: 600,
          body: EventArea({ Displaylists, url_args }),
        },
      ]),
      Modals({ Displaylists, url_args }),
      YourBrowserWindowIsTooSmall()
    );
  },
});



// WEBPACK FOOTER //
// ./src/components/main_view/index.js